import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";

import service1Img from "./assets/servicepage/air/air.jpg";
import service2Img from "./assets/servicepage/ocean/ocean.jpg";
import service3Img from "./assets/servicepage/road/road.jpg";
import service4Img from "./assets/servicepage/warehouse/warehouse.jpg";
import service5Img from "./assets/servicepage/customs/customs.jpg";

import air1 from "./assets/servicepage/air/1.png";
import air2 from "./assets/servicepage/air/2.png";
import air3 from "./assets/servicepage/air/3.png";
import air4 from "./assets/servicepage/air/4.png";
import air5 from "./assets/servicepage/air/5.png";

import road1 from "./assets/servicepage/road/1.png";
import road2 from "./assets/servicepage/road/2.png";
import road3 from "./assets/servicepage/road/3.png";
import road4 from "./assets/servicepage/road/4.png";
import road5 from "./assets/servicepage/road/5.png";

import ocean1 from "./assets/servicepage/ocean/1.png";
import ocean2 from "./assets/servicepage/ocean/2.png";
import ocean3 from "./assets/servicepage/ocean/3.png";
import ocean4 from "./assets/servicepage/ocean/4.png";
import ocean5 from "./assets/servicepage/ocean/5.png";

import warehouse1 from "./assets/servicepage/warehouse/1.png";
import warehouse2 from "./assets/servicepage/warehouse/2.png";
import warehouse3 from "./assets/servicepage/warehouse/3.png";
import warehouse4 from "./assets/servicepage/warehouse/4.png";
import warehouse5 from "./assets/servicepage/warehouse/5.png";
import warehouse6 from "./assets/servicepage/warehouse/6.png";

import customs1 from "./assets/servicepage/customs/1.png";
import customs2 from "./assets/servicepage/customs/2.png";
import customs3 from "./assets/servicepage/customs/3.png";
import customs4 from "./assets/servicepage/customs/4.png";
import customs5 from "./assets/servicepage/customs/5.png";

import bgLines from "./assets/service lines.svg";
import bgWhiteLines from "./assets/linesWhite.svg";

const services = [
  {
    id: "airFreight",
    title1: "Air",
    title2: "Freight",
    subtitle: "Speed meets precision with every mile in the sky.",
    button: "Request Air Freight Now",
    image: service1Img,
    offersText:
      "A full range of air freight services designed for speed, security and global coverage. From express shipments to time-critical cargo, we handle it all including hazardous materials and AOG (Aircraft on Ground) shipments. With 24/7 control tower monitoring, onboard courier options, direct routes and real-time tracking, we ensure your cargo moves faster, smarter and with complete visibility.",
    offerItems: [
      { topLine: "Express &", bottomLine: "Consolidated Services", icon: air1 },
      { topLine: "Control Tower", bottomLine: "With 24/7 Monitoring", icon: air2 },
      { topLine: "Dedicated Air", bottomLine: "Freight Professionals", icon: air3 },
      { topLine: "On-Board", bottomLine: "Courier & air Charter", icon: air4 },
      { topLine: "Real Time", bottomLine: "Tracking And Updates", icon: air5 },
    ],
  },
  {
    id: "oceanFreight",
    title1: "Ocean",
    title2: "Freight",
    subtitle: "Scale your shipping with global reach and cost control.",
    button: "Get an Ocean Freight Quote",
    image: service2Img,
    offersText:
      "Whether it’s full container loads (FCL) or less-than-container (LCL) shipments, Big Blue connects you to global trade routes through trusted carrier relationships. Our ocean freight services include project cargo, reefer shipments, Ro/Ro, flatbeds, and buyer consolidation across multiple countries. With our own inbound/outbound consolidations and direct contracts with major carriers, you get better pricing, reliability, and flexibility.",
    offerItems: [
      { topLine: "FCL", bottomLine: "And LCL Consolidation", icon: ocean1 },
      { topLine: "Project Cargo", bottomLine: "Ro/Ro, Reefers, Flatbeds, Oversized Loads", icon: ocean2 },
      { topLine: "Buyer", bottomLine: "Consolidation Services", icon: ocean3 },
      { topLine: "Global", bottomLine: "Port-to-port And Door-to-door reach", icon: ocean4 },
      { topLine: "Strong Carrier", bottomLine: "Relationships For Better Terms", icon: ocean5 },
    ],
  },
  {
    id: "roadFreight",
    title1: "Road",
    title2: "Freight",
    subtitle: "Seamless transport across Canada, USA, and Mexico.",
    button: "Get Road Freight Quote",
    image: service3Img,
    offersText:
      "From domestic next-day delivery to cross-border full truckload (FTL) and less-than-truckload (LTL), Big Blue ensures reliable inland freight with precision tracking. Our modern fleet includes mega trailers, double deckers, and tail-lift vehicles optimized for various industries. We also provide factory-to-hub shuttle runs, PODs, and exception reporting.",
    offerItems: [
      { topLine: "Cross-Border", bottomLine: "FTL & LTL Solutions", icon: road1 },
      { topLine: "Dedicated", bottomLine: "Express Vans", icon: road2 },
      { topLine: "Milk Run", bottomLine: "Services And Engineered Delivery Models", icon: road3 },
      { topLine: "Web-Based", bottomLine: "Tracking And Reporting", icon: road4 },
      { topLine: "Modern Fleet", bottomLine: "With GPS and Real-time Delivery Updates", icon: road5 },
    ],
  },
  {
    id: "warehousing",
    title1: "Warehousing &",
    title2: "Inventory Solutions",
    titleSize1: "text-[45px]",
    titleSize2: "text-[40px]",
    subtitle: "Seamless transport across Canada, USA, and Mexico.",
    button: "Get Warehousing & Inventory Quote",
    image: service4Img,
    offersText:
      "Big Blue offers bonded and non-bonded warehousing backed by intelligent inventory management and scalable 3PL support. Whether you're storing seasonal goods, managing high-value stock or fulfilling rapid orders, we give you complete control with real-time tracking, flexible space and reduced customs costs through deferred duties. From repacking and labeling to order handling and control tower visibility, our systems are built to adapt to your supply chain.",
    offerItems: [
      { topLine: "Bonded", bottomLine: "& Non-bonded Warehouse Space", icon: warehouse1 },
      { topLine: "Short", bottomLine: "And Long-term Storage", icon: warehouse2 },
      { topLine: "Labeling,", bottomLine: "Repacking & Value-added Services", icon: warehouse3 },
      { topLine: "Real-Time", bottomLine: "Inventory Tracking & Custom Reporting", icon: warehouse4 },
      { topLine: "In-Bond ", bottomLine: "Transfers And Customs-cleared Stockholding", icon: warehouse5 },
      { topLine: "End-To-End", bottomLine: "3PL Operations Tailored To Your Business", icon: warehouse6 },
    ],
  },
  {
    id: "customs",
    title1: "Customs Clearance &",
    title2: "Compliance",
    titleSize1: "text-[45px]",
    titleSize2: "text-[40px]",
    subtitle: "Your single point of contact for smooth border crossings.",
    button: "Request Customs Support",
    image: service5Img,
    offersText:
      "Big Blue simplifies trade compliance across borders, handling all customs regimes for air, ocean, and road freight. We’re licensed, experienced, and trusted to get your cargo cleared fast and correctly. From documentation to representation, we take the complexity off your plate.",
    offerItems: [
      { topLine: "Import,", bottomLine: "Export, And Transit Clearance", icon: customs1 },
      { topLine: "Commercial", bottomLine: "& Non-commercial Goods", icon: customs2 },
      { topLine: "Simplified", bottomLine: "Procedures, Bonded Guarantees", icon: customs3 },
      { topLine: "Authorized", bottomLine: "Shipper/consignee Licenses", icon: customs4 },
      { topLine: "Post-Entry", bottomLine: "And Document Handling", icon: customs5 },
    ],
  },
];

export default function ServicesSection({ sectionRefs, currentBgColor }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <section className="px-6 md:px-16 py-20 text-white space-y-32">
      <style>
        {`
          .service-section {
            scroll-margin-top: 120px;
          }
        `}
      </style>

      {services.map((service, idx) => (
        <div key={idx} id={service.id} className="service-section space-y-12" ref={sectionRefs[service.id]}>
          <div className={`flex flex-col lg:flex-row ${idx % 2 !== 0 ? "lg:flex-row-reverse" : ""} gap-8 items-start justify-center`}>
            <motion.div
              className="w-full lg:w-[40%] min-h-[650px] rounded-[40px] bg-cover bg-center relative flex flex-col justify-center p-10"
              style={{ backgroundImage: `url(${service.image})` }}
              initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <div className="absolute inset-0 bg-black/70 rounded-[40px]" />
              <div className="relative z-10 text-left text-white w-fit mx-auto">
                <h2 className={`${service.titleSize1 || "text-[65px]"} font-bold leading-none mb-0`}>
                  {service.title1}
                </h2>
                <h2 className={`${service.titleSize2 || "text-[60px]"} font-bold leading-none mb-0`}>
                  {service.title2}
                </h2>
                <p className="italic font-medium text-[25px] mt-5 mb-20 w-[100%]">
                  {service.subtitle}
                </p>
                <button className="bg-[#00B2FF]/60 hover:bg-[#00B2FF] hover:shadow-[0_0_15px_#00B2FF] text-white px-6 py-4 rounded-xl text-lg mt-2 shadow-lg transition">
                  <Link to="/contact">{service.button}</Link>
                </button>
              </div>
            </motion.div>

            <motion.div
              className="w-full lg:w-[40%] bg-transparent border border-white rounded-[40px] p-8 min-h-[650px] flex items-center justify-center"
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <div className="text-left max-w-[100%]">
                <h3 className="text-[52px] font-bold text-[#00B2FF] mb-4">
                  Big Blue Offers
                </h3>
                <p className="text-[25px] leading-relaxed text-white">
                  {service.offersText}
                </p>
              </div>
            </motion.div>
          </div>

          <div
            className="relative text-center pt-10 md:pt-40 min-h-0 md:min-h-[850px] lg:min-h-[1000px]"
            ref={sectionRefs[`${service.id}Offer`]}
          >
            <div className="max-w-7xl mx-auto flex flex-col items-center relative">
              {!isMobile && (
                <motion.div
                  className="absolute top-20 left-28 transform -translate-x-1/2 z-0 w-full"
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 0.8, scale: 1 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: true }}
                >
                  <img
                    src={currentBgColor === '#86cde9' ? bgWhiteLines : bgLines}
                    alt="Background lines"
                    className="w-[75%] h-auto"
                  />
                </motion.div>
              )}

              <motion.h2
                className="text-[45px] md:text-[80px] font-bold z-10 mt-0 md:mt-[250px] relative"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.7, ease: "easeInOut" }}
                viewport={{ once: true }}
              >
                What We Offer
              </motion.h2>

              <div className="md:hidden w-full mt-12 px-4">
                <div className="flex flex-col items-center gap-6">
                  {service.offerItems.map((item, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      viewport={{ once: true }}
                      className="w-full max-w-md"
                    >
                      <MobileOfferBox item={item} />
                    </motion.div>
                  ))}
                </div>
              </div>

              <div className="hidden md:block">
                {service.offerItems[0] && (
                  <motion.div
                    className="absolute top-[40px] left-[0]"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.7, ease: "easeInOut", delay: 0.2 }}
                    viewport={{ once: true }}
                  >
                    <OfferBox item={service.offerItems[0]} />
                  </motion.div>
                )}

                {service.offerItems[1] && (
                  <motion.div
                    className="absolute top-[60px] right-[0]"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.7, ease: "easeInOut", delay: 0.4 }}
                    viewport={{ once: true }}
                  >
                    <OfferBox item={service.offerItems[1]} />
                  </motion.div>
                )}

                {service.offerItems[2] && (
                  <motion.div
                    className="absolute top-[-20px] left-[40%]"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.7, ease: "easeInOut", delay: 0.6 }}
                    viewport={{ once: true }}
                  >
                    <OfferBox item={service.offerItems[2]} />
                  </motion.div>
                )}

                {service.offerItems[3] && (
                  <motion.div
                    className="absolute top-[460px] right-[5%]"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.7, ease: "easeInOut", delay: 0.8 }}
                    viewport={{ once: true }}
                  >
                    <OfferBox item={service.offerItems[3]} />
                  </motion.div>
                )}

                {service.offerItems[4] && (
                  <motion.div
                    className="absolute top-[440px] left-[5%]"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.7, ease: "easeInOut", delay: 1 }}
                    viewport={{ once: true }}
                  >
                    <OfferBox item={service.offerItems[4]} />
                  </motion.div>
                )}

                {service.offerItems[5] && (
                  <motion.div
                    className="absolute top-[500px] right-[35%]"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.7, ease: "easeInOut", delay: 1.2 }}
                    viewport={{ once: true }}
                  >
                    <OfferBox item={service.offerItems[5]} />
                  </motion.div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}

function OfferBox({ item }) {
  return (
    <div className="bg-[#001737] rounded-2xl shadow-xl w-fit max-w-[330px] px-7 py-7 flex items-center gap-5">
      <div className="text-left">
        <div className="text-[32px] font-bold leading-tight whitespace-nowrap">
          {item.topLine}
        </div>
        <div className="text-[18px] font-medium leading-snug text-left break-words max-w-[250px]">
          {item.bottomLine}
        </div>
      </div>
      <img
        src={item.icon}
        alt=""
        className="w-12 h-12 object-contain shrink-0"
      />
    </div>
  );
}

function MobileOfferBox({ item }) {
  return (
    <div className="bg-[#001737] rounded-2xl shadow-xl w-full px-5 py-5 flex items-center gap-4">
      <img
        src={item.icon}
        alt=""
        className="w-10 h-10 object-contain shrink-0"
      />
      <div className="text-left flex-1">
        <div className="text-xl font-bold leading-tight">
          {item.topLine}
        </div>
        <div className="text-base font-medium leading-snug">
          {item.bottomLine}
        </div>
      </div>
    </div>
  );
}